import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectHeroActions } from '@repo/store/maps/slices/mapData';
import type { MapDataHeroAction } from '@repo/types/maps/map-types';
import { useMemo } from 'react';
export function getHeroActionPinIds(action: MapDataHeroAction, mappedKey: 'resultPins' | 'triggerPins', mapExternalId: string | undefined): ReadonlyArray<string> {
  if (!mapExternalId) return [];
  return action[mappedKey][mapExternalId] ?? [];
}
export function getHeroActionResultPinIds(action: MapDataHeroAction, mapExternalId?: string): ReadonlyArray<string> {
  return getHeroActionPinIds(action, 'resultPins', mapExternalId);
}
export function getHeroActionTriggerPinIds(action: MapDataHeroAction, mapExternalId?: string): ReadonlyArray<string> {
  return getHeroActionPinIds(action, 'triggerPins', mapExternalId);
}
export function resolveHeroActionForPin(heroActions: ReadonlyArray<MapDataHeroAction>, selectedPinId: string | undefined, mapExternalId?: string): MapDataHeroAction | null {
  if (!selectedPinId) return null;
  const candidates = heroActions.filter(action => getHeroActionTriggerPinIds(action, mapExternalId).includes(selectedPinId));
  if (candidates.length === 0) return null;
  if (candidates.length === 1) return candidates[0] ?? null;
  const sorted = [...candidates].sort((a, b) => {
    if (b.priority !== a.priority) return b.priority - a.priority;
    return a.externalId.localeCompare(b.externalId);
  });
  return sorted[0] ?? null;
}
export function useHeroActionForPin(selectedPinId) {
  const $ = _c(4);
  const heroActions = useAppSelector(selectHeroActions);
  const mapExternalId = useAppSelector(selectExternalMapId);
  let t0;
  if ($[0] !== heroActions || $[1] !== mapExternalId || $[2] !== selectedPinId) {
    t0 = resolveHeroActionForPin(heroActions, selectedPinId, mapExternalId);
    $[0] = heroActions;
    $[1] = mapExternalId;
    $[2] = selectedPinId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}